import myImg from "../mridul.jpg";
import "./About.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function About() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div id="about" className="container-fluid">
      <h2 className="topic-head">About Me</h2>
      <div className="row">
        <img
          loading="lazy"
          data-aos="fade-right"
          data-aos-once="true"
          src={myImg}
          alt="Mridul Goel"
          className="col-lg-4 image"
        />
        <div
          className="col-lg-8 d-flex justify-content-center flex-column summary"
          data-aos-once="true"
          data-aos="fade-up"
        >
          <div className="d-flex justify-content-center flex-column">
            <p className="mb-3">
              I'm an <span className="embolden">AI Engineer and Software Developer</span> with a passion for building intelligent solutions that drive business impact. With a strong foundation in Computer Science and extensive hands-on experience, I specialize in developing and deploying scalable AI/ML models and applications.
            </p>
            <p className="mb-3">
              My journey in tech has been driven by a relentless curiosity and a desire to solve complex problems. As CTO at <span className="embolden">Drifko Tech</span>, I led a team of developers and spearheaded the creation of multiple SaaS products, driving a <span className="embolden">900% revenue surge</span>. At <span className="embolden">PNB MetLife</span>, I've been recognized as an <span className="embolden">AI Champion</span> for my work in automating key business processes and fostering innovation.
            </p>
            <p className="mb-3">
              I thrive in fast-paced, collaborative environments. I'm a <span className="embolden">SIH 2024 Finalist</span> and have a track record of success in over 20 hackathons. I'm proficient in <span className="embolden">Python, FastAPI, PyTorch, and deploying models with Docker</span>, and I'm always eager to learn new technologies.
            </p>
          </div>
          <a
            className="button-link cool-btn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download Mridul Goel's Resume"
            href="https://drive.google.com/file/d/1FG0oKq9gI4kqcE1biMrNVNgKGtHby5XX"
          >
            Download Resume
          </a>
        </div>
      </div>
    </div>
  );
}

export default About;